<template>
    <tbody>
    <tr v-if="data.length" v-for="(row, rowIndex) in data" :key="rowIndex" :id="getRowId(rowIndex)" v-bind:style="getTrStyleObject(rowIndex)">
        <template v-for="(column, columnIndex) in columns" v-if="isShow(column.field)">
            <template v-if="column.visible">
                <template v-if="customTableBodyTemplate && (!isFieldShowDatesComparison(column.field) && !datesComparisonEnabled)">
                    <slot :name="(fixed ? 'customBodyDataFixed' : 'customBodyData')"
                          :column="column"
                          :columnIndex="columnIndex"
                          :row="row"
                          :rowIndex="rowIndex">
                    </slot>
                </template>
                <template v-else>
                    <template v-if="(isFieldShowDatesComparison(column.field) && datesComparisonEnabled)">
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                {{getDateRangeAValue(row.node.metrics, column.field) | format(column.format)}}
                            </div>
                        </td>
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                {{getDateRangeBValue(row.node.metrics, column.field) | format(column.format)}}
                            </div>
                        </td>
                        <template v-if="!column.isCompareColumn">
                            <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                                <div>
                                    {{getChangeValueBetweenDates(row.node.metrics, column.field) | formatCustom('integer')}}
                                </div>
                            </td>
                            <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                                <div>
                                    {{getChangePercentageValueBetweenDates(row.node.metrics, column.field) | formatCustom('percentage', 2, '%')}}
                                </div>
                            </td>
                        </template>
                    </template>
                    <template v-else-if="fieldNameDropDown.length && showLinkDropDownMenu.length && fieldNameDropDown.includes(column.field)">
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <div>
                                <a class="table-field__link" @click="toggleMenu(rowIndex)" style="cursor: pointer;">
                                    <span>{{getFieldValue(row, column.field, column.isMetricValue + column.isCompareColumn) | format(column.format)}}</span>
                                    <i class="arrow-drop-down"></i>
                                </a>

                                <div class="dropdown-menu-wrapper"
                                     v-if="showLinkDropDownMenu[rowIndex]"
                                     v-bind:style="showLinkDropDownMenu[rowIndex] ? {'z-index': 3} : ''">
                  <span class="close-icon-wrapper">
                      <i class="close" @click="closeDropDownMenu(rowIndex)"></i>
                  </span>
                                    <div class="dropdown-menu">
                                        <ul>
                                            <li v-if="!$md.mobile()">
                                                <span @click="showChart(row.node, rowIndex)">7 days range chart</span>
                                            </li>
                                            <li v-for="item in dropDownMenuUrls">
                                                <router-link :to="{ name: item.link, query: prepareUrlParams(row, item.paramsList, item.commonParamsList)}" target= '_blank'>{{item.label}}</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </template>
                    <template v-else-if="editableFieldsList.includes(column.field)">
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}" style="cursor: pointer;">
              <span v-on:dblclick="makeColumnEditable(column.field, rowIndex, getFieldValue(row, column.field, column.isMetricValue))">
                  <template v-if="editedFieldName == column.field && rowIndex == editedFieldRow">
                      <input v-model="editedFieldModel" v-on:keyup.enter="updateFieldValue" v-on:keyup.esc="cancelEdition" class="editable_column">
                  </template>
                  <template v-else>
                      <span class="editable_column">
                          {{getFieldValue(row, column.field, column.isMetricValue + column.isCompareColumn) | format(column.format)}}
                      </span>
                  </template>
              </span>
                        </td>
                    </template>
                    <template v-else-if="column.format.type == 'array'">
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            <template v-for="value in getFieldValue(row, column.field, column.isMetricValue)">
                                <p class="cc-label-wrapper">{{value.value | format(column.format)}}</p>
                            </template>
                        </td>
                    </template>
                    <template v-else>
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            {{getFieldValue(row, column.field, (column.isMetricValue + column.isCompareColumn)) | format(column.format)}}
                        </td>
                    </template>
                </template>
            </template>

            <template v-else-if="column.dynamicField && isSellingPartnersExists && column.originalField !== undefined">
                <template v-if="customTableBodyDynamicFieldTemplate">
                    <slot :name="(fixed ? 'customBodyDynamicFieldDataFixed' : 'customBodyDynamicFieldData')"
                          :column="column"
                          :columnIndex="columnIndex"
                          :row="row"
                          :rowIndex="rowIndex">
                    </slot>
                </template>
                <template v-else>
                    <template v-for="(partnerName, partnerId) in getPartners">
                        <td v-bind:class="column.field" v-bind:style="{'min-width': column.width}">
                            {{getColumnValueByPartnerId(partnerId, getFieldValue(row, 'feeds', true), column.originalField) | format(column.format)}}
                        </td>
                    </template>
                </template>
            </template>
        </template>
    </tr>
    </tbody>
</template>

<script>
    import '@/style/reports/base_table_style.scss';

    import moment from 'moment';
    import tableColumnViewMixin from '@/components/reports/mixins/tableColumnViewMixin';
    import hoverTableMixin from '@/components/reports/mixins/hoverTableMixin';
    import sellingPartnerMixin from '@/components/reports/mixins/sellingPartnerMixin';
    import filterMixin from '@/components/mixins/filterMixin';
    import fixTableMixin from '@/components/reports/mixins/fixTableMixin';
    import datesComparisonTableMixin from '@/components/reports/mixins/datesComparisonTableMixin';
    import sortTableMixin from '@/components/reports/mixins/sortTableMixin';

    export default {
        name: "table-body",
        components: {

        },
        props: {
            data: {
                type: Array,
                required: true
            },
            columns: {
                type: Array,
                required: true
            },
            namespace: {
                type: String,
                required: true
            },
            hoveredColumns: {
                type: Object,
                required: false
            },
            defaultColumns: {
                type: Array,
                required: true
            },
            dropDownMenuUrls: {
                type: Array,
                required: false,
            },
            fieldNameDropDown: {
                type: Array,
                required: false
            },
            editableFieldsList: {
                type: Array,
                required: false,
                default: []
            },
            fixed: {
                type: Boolean,
                default: false,
                required: false
            },
            customTableBodyTemplate: {
                type: Object,
                requried: false
            },
            customTableBodyDynamicFieldTemplate: {
                type: Object,
                required: false,
                default: null
            }
        },
        mixins: [
            tableColumnViewMixin,
            hoverTableMixin,
            sellingPartnerMixin,
            filterMixin,
            fixTableMixin,
            datesComparisonTableMixin,
            sortTableMixin
        ],
        data(){
            return {
                showLinkDropDownMenu: Array(this.dataLength).fill(false),
            }
        },
        computed: {
        },
        filters: {

        },
        methods: {
            getRowId: function(rowIndex){
                if (this.fixed)
                {
                    return this.namespace + 'FixedRowColumn' + rowIndex;
                }
                else
                {
                    return this.namespace + 'RowColumn' + rowIndex;
                }
            },
            getRowIdOppositeTable: function(rowIndex){
                if (this.fixed)
                {
                    return this.namespace + 'RowColumn' + rowIndex;
                }
                else
                {
                    return this.namespace + 'FixedRowColumn' + rowIndex;
                }
            },
            isShow: function(columnName){

                let condition = (this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist);

                if (this.fixed)
                {
                    return condition;
                }
                else
                {
                    return !condition;
                }
            },
            getFieldValue: function(dataRow, columnName, isMetric){
                let data = dataRow.node;
                let value = null;

                if (this.isFieldShowDatesComparison(columnName) && this.datesComparisonEnabled)
                {
                    value = this.getDateRangeAValue(data.metrics, columnName);
                }

                if (isMetric)
                {
                    value = data.metrics[0][columnName] !== undefined ? data.metrics[0][columnName] : '';
                }
                else
                {
                    value = data[columnName] !== undefined ? data[columnName] : '';
                }

                return value;
            },
            toggleMenu: function(index){
                this.$set(this.showLinkDropDownMenu, index, !this.showLinkDropDownMenu[index]);
            },
            showChart: function(data, index){
                let filters = this.$store.getters[this.namespace + '/getFilters']['filters'];

                let dateStart = moment(filters.dateRange.startDate).clone();
                let dateEnd = moment(filters.dateRange.endDate).clone();

                let startDate = dateStart;
                let endDate = dateEnd;

                if (dateEnd.diff(dateStart, 'days') < 4)
                {
                    startDate = dateEnd.clone().add(-6, 'days');
                    endDate = dateEnd.clone();
                }

                var generateDatesList = function(startDate, endDate){
                    let dates = [];
                    let day = startDate.clone();

                    dates.push([startDate.format("YYYY-MM-DD"), startDate.format("YYYY-MM-DD")]);

                    while (day.isBefore(endDate, 'day'))
                    {
                        day = day.add(1, 'day');

                        dates.push([day.format("YYYY-MM-DD"), day.format("YYYY-MM-DD")]);
                    }

                    return dates;
                };

                let reportFilters = this.$store.getters[this.namespace + '/getFilters'];

                let objects = this.$store.dispatch(this.namespace + '/getReportChartsData',
                    {
                        columns: this.defaultColumns.filter(column => column.isMetricValue === true),
                        siteId: data.siteId,
                        sourceId: data.sourceId,
                        adGroupName: data.adGroupName,
                        campaignName: data.campaignName,
                        datesList: generateDatesList(startDate, endDate),
                        reportFilters: reportFilters
                    });

                let that = this;

                this.$store.dispatch(this.namespace + '/startLoading');

                objects.then(function(result){
                    if (result.report !== undefined && result.report.edges.length > 0)
                    {
                        that.$store.dispatch(that.namespace + '/setReportChartsData', result.report.edges[0].node);
                        that.$store.dispatch(that.namespace + '/setSideBarStatus', true);
                    }

                    that.$store.dispatch(that.namespace + '/finishLoading');
                });

                this.closeDropDownMenu(index);
            },
            closeDropDownMenu: function(index){
                this.$set(this.showLinkDropDownMenu, index, false);
            },
            getTrStyleObject: function(rowIndex)
            {
                let styleObj = {};

                let rowRef = document.querySelector('#' + this.getRowIdOppositeTable(rowIndex));

                if (rowRef != undefined)
                {
                    styleObj.height = rowRef.offsetHeight + 'px';
                }

                return styleObj;
            },
            getColumnClasses(columnName, rowIndex){
                return {
                    //'hovered': this.isColumnHovered(columnName),
                    //'alter': (this.isColumnHovered(columnName) && rowIndex % 2 === 0),
                    //'hidden': (this.isColumnFixed(columnName) && this.isAnyFixedColumnsExist)
                    //'hovered': this.hoveredColumns[columnName]
                };
            },
            getColumnValueByPartnerId: function(partnerId, data, fieldName){
                let result = null;

                result = data.find(item => item.feedId == partnerId);

                if (result !== undefined && result !== null && result[fieldName] !== undefined)
                {
                    return result[fieldName];
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    tbody > tr {
        text-align: left;

        &:hover {
            background: #f5f5f5;
        }

        & > * {
            font-size: 13px;
        }

        & > td {
            border-right: 1px solid #f3f3f3;
            padding: 5px;
        }

        & > td.hovered {
            background: #f5f5f5;

            &.alter{
                background: #eef1f4;
            }
        }

        & > td.hidden {
            display: none;
        }

        & > td:last-child {
            border: 0;
        }
    }
</style>

<style lang="scss" scoped>
    .table-field__link {
        text-decoration: none;
        color: #0051ff;
        display: flex;
        align-items: center;

        &:hover {
            text-decoration: underline;
        }

        .arrow-drop-down {
            text-decoration: none;
            display: inline-block;
            width: 1.5em;
            height: 1.5em;
            color: #fff;
            background-image: url('/static/img/icon-arrow-drop-down-blue.svg');
            background-repeat: no-repeat;
            background-position: center;
            flex-shrink: 0;
        }
    }

    .dropdown-menu-wrapper {
        position: absolute;
        background-color: #fff;
        margin-left: 20px;
        padding: 5px;
        border: 1px solid $border-color;
        border-radius: 3px;
        box-shadow: 1px 3px 7px 1px #cbcccd;

        .close-icon-wrapper {
            display: flex;
            justify-content: flex-end;

            & > i.close {
                display: inline-block;
                width: 1em;
                height: 1em;
                color: #fff;
                background-image: url('/static/img/icon-close-black.svg');
                background-repeat: no-repeat;
                background-position: center;
                cursor: pointer;
            }
        }

        & > .dropdown-menu {
            padding: 0 10px 10px 10px;

            & > ul {
                list-style: none;
                padding: 0;
                margin: 0;

                & > li {
                    margin-top: 5px;
                    margin-bottom: 5px;

                    & > a {
                        color: #666666;
                        text-decoration: none;
                        line-height: 24px;

                        &:hover {
                            color: #0051ff;
                        }
                    }

                    & > span {
                        cursor: pointer;
                        color: #666666;
                        text-decoration: none;
                        line-height: 24px;

                        &:hover {
                            color: #0051ff;
                        }
                    }
                }
            }
        }
    }

    tbody > tr {
        text-align: left;

        &:hover {
            background: #f5f5f5;
        }

        & > * {
            font-size: 13px;
        }

        & > td {
            border-right: 1px solid #f3f3f3;
            padding: 5px;
        }

        & > td.hovered {
            background: #f5f5f5;

            &.alter{
                background: #eef1f4;
            }
        }

        & > td.hidden {
            display: none;
        }

        & > td:last-child {
            border: 0;
        }
    }

    .sticky-body-column {
        position: relative;
        display: table-cell;
        transition: 0.3s;
    }

    .sticky-body-column:nth-last-child {
        border-right: 3px solid #cecece;
    }

    .editable_column {
        transition: opacity 1s ease-out;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/common/table/TableBody.vue